import BaseError from './BaseError';
import { TriangleExclamationRegularGlyph } from '@acast-tech/decibel-glyphs';

const ServerError = () => {
  return (
    <BaseError
      icon={<TriangleExclamationRegularGlyph />}
      title="Server error"
      desc="It looks like something went wrong on our end. Please try refreshing the page. If the problem persists, feel free to reach out to our support team."
    />
  );
};

export default ServerError;
